import { render, staticRenderFns } from "./SectionEmsPayment.vue?vue&type=template&id=0af56254&scoped=true"
import script from "./SectionEmsPayment.vue?vue&type=script&lang=js"
export * from "./SectionEmsPayment.vue?vue&type=script&lang=js"
import style0 from "./SectionEmsPayment.vue?vue&type=style&index=0&id=0af56254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af56254",
  null
  
)

export default component.exports